import React from 'react';

import { useTranslation } from '@/src/i18n';
import { analyticsEvent } from '@/src/analytic_tag_manager';
import useTLCSpecialities from '@/src/hooks/useTLCSpecialities';
import TLCFilter from './TLCFilter';

type Props = {
  filters: Record<string, any>;
  selectValue: (filter: Record<string, any>) => void;
};
const TLCSpecialityFilter = ({ filters, selectValue }: Props) => {
  const { t } = useTranslation();
  const { list: tlcSpecialities } = useTLCSpecialities();

  const updateSpeciality = (value?: string) => {
    analyticsEvent({
      category: 'TeleconsultationOnDemand',
      action: 'Search',
      label: value,
    });

    selectValue({ speciality: value });
  };

  const resetValue = () => selectValue({ speciality: undefined });
  const selectedValue = tlcSpecialities.find(
    x => x.value === filters.speciality,
  )?.value;

  return (
    <TLCFilter
      updateValue={updateSpeciality}
      resetValue={resetValue}
      selectedValue={selectedValue}
      options={tlcSpecialities}
      placeholder={t('tlc_filter_speciality_label')}
    />
  );
};

export default TLCSpecialityFilter;
